import { FormControl } from "@primer/react";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { lichSuXuongPhongYTeApi } from "../../api/lichSuXuongPhongYTeApi";
import MyHtmlEditor from "../../components/html-editor";
import SelectBoxHocSinhSearch from "../../components/selectbox-hocsinh-search/SelectBoxHocSinhSearch";
import Button from "../../components/ui/button";
import Modal from "../../components/ui/modal";
import ModalActions from "../../components/ui/modal/ModalActions";
import TextInput from "../../components/ui/text-input";
import { useCommonContext } from "../../contexts/common";
import { NotifyHelper } from "../../helpers/toast";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";
import { ILichSuYteRequest } from "../../models/request/hoc-sinh/ILichSuYteRequest";

interface ILichSuYTeModalProps {
  id: number;
  onClose: () => void;
  onSuccess: () => void;
}
const LichSuXuongPhongYTeModal = (props: ILichSuYTeModalProps) => {
  const [isSaving, setIsSaving] = useState(false);
  const { translate } = useCommonContext();
  const { nam_hoc, dm_coso_id } = useCommonSelectedHook();

  const [formData, setFormData] = useState<ILichSuYteRequest>({
    ts_hocsinh_id: 0,
    tinh_trang: "",
    ket_qua: "",
  });

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    setError,
    control,
    setValue,
    trigger,
    formState: { errors, isValid },
  } = useForm<ILichSuYteRequest>({
    mode: "onChange", // Validate khi người dùng thay đổi input
    reValidateMode: "onChange", // Re-validate khi có thay đổi
    defaultValues: formData,
  });

  useEffect(() => {
    if (props.id > 0) {
      handleGetVm();
    }
  }, [props.id]);

  const handleGetVm = async () => {
    const res = await lichSuXuongPhongYTeApi.selectById(props.id);
    if (res.is_success) {
      const data: ILichSuYteRequest = {
        ...res.data,
      };
      setFormData(data);
      reset(data);
    } else {
      NotifyHelper.Error(res.message ?? "Error");
    }
  };

  const onSubmit = async (data: any) => {
    // Validate toàn bộ form trước khi submit
    const validationErrors: any = {};

    // Validate trường học
    if (!data.ts_hocsinh_id || data.ts_hocsinh_id === 0) {
      validationErrors.ts_hocsinh_id = "Vui lòng chọn học sinh";
    }
    // Validate tên lớp
    if (!data.tinh_trang || data.tinh_trang.trim() === "") {
      validationErrors.tinh_trang = "Vui lòng điền tên lớp";
    }

    // Nếu có lỗi validation, hiển thị lỗi và dừng submit
    if (Object.keys(validationErrors).length > 0) {
      Object.keys(validationErrors).forEach(field => {
        setError(field as any, {
          type: "manual",
          message: validationErrors[field]
        });
      });
      NotifyHelper.Error("Vui lòng kiểm tra lại thông tin đã nhập");
      return;
    }

    setIsSaving(true);
    try {
      let res: any;
      if (props.id > 0) {
        res = await lichSuXuongPhongYTeApi.update({
          ...data,
          id: props.id,
        });
      } else {
        res = await lichSuXuongPhongYTeApi.insert({
          ...data
        });
      }

      if (res.is_success) {
        NotifyHelper.Success(props.id > 0 ? "Cập nhật thành công" : "Thêm mới thành công");
        props.onSuccess();
      } else {
        NotifyHelper.Error(res.message ?? "Có lỗi xảy ra khi lưu dữ liệu");
      }
    } catch (error) {
      NotifyHelper.Error("Có lỗi xảy ra khi lưu dữ liệu");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      // width={"60%"}
      sx={{
        width: "60%"
      }}
      title={props.id > 0 ? "Cập nhật" : "Thêm mới"}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-md-6 mb-6">
            <FormControl>
              <FormControl.Label>Học sinh</FormControl.Label>
              <Controller
                name="ts_hocsinh_id"
                control={control}
                rules={{
                  required: "Vui lòng chọn học sinh",
                  validate: (value) => {
                    if (!value || value === 0) {
                      return "Vui lòng chọn học sinh";
                    }
                    return true;
                  }
                }}
                render={({ field }) => (
                  <SelectBoxHocSinhSearch
                    value={field.value}
                    onValueChanged={(value) => {
                      field.onChange(value);
                      clearErrors("ts_hocsinh_id");
                    }}
                  />
                )}
              />
              {errors.ts_hocsinh_id && (
                <FormControl.Validation variant="error">
                  {errors.ts_hocsinh_id.message}
                </FormControl.Validation>
              )}
            </FormControl>
          </div>
          <div className="col-md-12 mb-12">
            <FormControl>
              <FormControl.Label>Tình trạng</FormControl.Label>
              <Controller
                name="tinh_trang"
                control={control}
                rules={{
                  required: "Vui lòng nhập tình trạng",
                  validate: (value) => {
                    if (!value) {
                      return "Vui lòng nhập tình trạng";
                    }
                    return true;
                  }
                }}
                render={({ field }) => (
                  <TextInput
                    block
                    value={field.value}
                    onChange={(e) => {
                      field.onChange(e.target.value);
                      clearErrors("tinh_trang");
                    }}
                    placeholder="Nhập tình trạng"
                  />
                )}
              />
              {errors.tinh_trang && (
                <FormControl.Validation variant="error">
                  {errors.tinh_trang.message}
                </FormControl.Validation>
              )}
            </FormControl>
          </div>
          <div className="col-md-12 mb-12">
            <FormControl>
              <FormControl.Label>Kết quả</FormControl.Label>
              <Controller
                name="ket_qua"
                control={control}
                rules={{
                  
                }}
                render={({ field }) => (
                  <MyHtmlEditor
                    value={field.value ?? ""}
                    onValueChanged={(value) => {
                      field.onChange(value);
                    }}
                  />
                )}
              />
              {errors.ket_qua && (
                <FormControl.Validation variant="error">
                  {errors.ket_qua.message}
                </FormControl.Validation>
              )}
            </FormControl>
          </div>
        </div>

        <ModalActions>
          <Button text="Base.Label.Close" onClick={props.onClose} />
          <Button
            text="Base.Label.Save"
            variant="primary"
            type="submit"
            isLoading={isSaving}
            disabled={isSaving}
          />
        </ModalActions>
      </form>
    </Modal>
  );
};

export default LichSuXuongPhongYTeModal;
